var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentionEmailBridgeSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "#677487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM7 11.9751C7 9.2151 9.24 6.9751 12 6.9751C14.76 6.9751 17 9.2151 17 11.9751V12.6901C17 13.6751 16.235 14.4751 15.25 14.4751C14.655 14.4751 14.095 14.1851 13.77 13.7401C13.32 14.1951 12.69 14.4751 12 14.4751C10.62 14.4751 9.5 13.3551 9.5 11.9751C9.5 10.5951 10.62 9.4751 12 9.4751C13.38 9.4751 14.5 10.5951 14.5 11.9751V12.6901C14.5 13.0851 14.855 13.4751 15.25 13.4751C15.645 13.4751 16 13.0851 16 12.6901V11.9751C16 9.8051 14.17 7.9751 12 7.9751C9.83 7.9751 8 9.8051 8 11.9751C8 14.1451 9.83 15.9751 12 15.9751H14.5V16.9751H12C9.24 16.9751 7 14.7351 7 11.9751ZM10.5 11.9751C10.5 12.8051 11.17 13.4751 12 13.4751C12.83 13.4751 13.5 12.8051 13.5 11.9751C13.5 11.1451 12.83 10.4751 12 10.4751C11.17 10.4751 10.5 11.1451 10.5 11.9751Z",
    fill: "#EE9A8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionEmailBridgeSelected);
export default __webpack_public_path__ + "static/media/mentionEmailBridgeSelected.b1db27f1c52f7031e3fe638e36a4ff69.svg";
export { ForwardRef as ReactComponent };